import React, { useState } from 'react';
import { DeleteIcon } from '../../assets/icons';
import { Alert, Button, Modal } from '../../components/shared';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { deleteServiceAPI } from '../../redux/features/services/servicesSlice';
import EditServiceModal from './AddNewService';

const Children = (
  restProps: { [key: string]: any },
  recallList: () => void
) => {
  console.log('restProps in children', restProps);
  // REDUX STATES
  const { deleteServiceLoading, error } = useAppSelector(
    (state) => state?.allServices
  );
  const dispatch = useAppDispatch();
  //STATES
  const [isOpenDeteleModal, setIsOpenDeleteModal] = useState<boolean>(false);
  const [isOpenEditModal, setIsOpenEditModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [isError, setIsError] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  // HANDLE DELETE SERVICE
  const handleDeleteService = async () => {
    setIsError(false);
    setIsSuccess(false);
    const data = await dispatch(deleteServiceAPI({ id: restProps?.row?.id }));
    if (data.meta.requestStatus === 'rejected') {
      setIsError(true);
    }

    if (data.meta.requestStatus === 'fulfilled') {
      setIsSuccess(true);
      setSuccessMessage(data.payload?.message);
    }
  };

  //HANDLE ONCLOSE
  const onClose = () => {
    setIsOpenDeleteModal(false);
    recallList();
  };
  return (
    <React.Fragment>
      <div className='flex flex-col'>
        {/* Delete Service Modal */}
        <button
          className='hover:cursor-pointer  transition-all duration-300 rounded-[4px] hover:bg-gray-200 p-2 flex justify-start items-start gap-2'
          onClick={() => setIsOpenEditModal(true)}
        >
          <DeleteIcon className='w-[20px] h-[20px]' />
          Edit Service
        </button>

        {/* Delete Service Modal */}
        <button
          className='hover:cursor-pointer  transition-all duration-300 rounded-[4px] hover:bg-gray-200 p-2 flex justify-start items-start gap-2'
          onClick={() => setIsOpenDeleteModal(true)}
        >
          <DeleteIcon className='w-[20px] h-[20px]' />
          Delete Service
        </button>
      </div>

      {/* Delete Service Modal */}
      <Modal
        open={isOpenDeteleModal}
        onClose={() => {
          setIsOpenDeleteModal(false);
          onClose();
        }}
        title='Delete Service'
        icon={<DeleteIcon className='w-[20px] h-[20px]' />}
      >
        <div className='mt-4'>
          {!isSuccess && (
            <p className='text-[1rem] leading-relaxed'>
              Are you sure you want to delete this{' '}
              <b>{restProps?.row?.serviceName}</b> service?
            </p>
          )}
          <Alert
            color={isError ? 'danger' : isSuccess ? 'success' : 'danger'}
            text={
              isError
                ? error
                  ? error
                  : 'Something went wrong'
                : isSuccess
                ? successMessage
                : null
            }
            showAlert={isError || isSuccess}
            onClose={onClose}
            isShowClose={isSuccess ? false : true}
          />
        </div>
        <div className='flex justify-end gap-2 mt-4'>
          <Button variant='secondary' color='danger' onClick={onClose}>
            {isSuccess ? 'Close' : 'Cancel'}
          </Button>
          {!isSuccess ? (
            <Button
              variant='primary'
              color='danger'
              onClick={handleDeleteService}
              loading={deleteServiceLoading}
            >
              Confirm
            </Button>
          ) : null}
        </div>
      </Modal>

      {/* ADD NEW SERVICE MODAL */}
      <EditServiceModal
        isOpen={isOpenEditModal}
        setIsOpen={setIsOpenEditModal}
        restProps={restProps}
        from='edit'
      />
    </React.Fragment>
  );
};

export default Children;
